import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs/Rx';
// import { JhiEventManager } from 'ng-jhipster';

import { SystemSetting } from './system-setting.model';
import { SystemSettingService } from './system-setting.service';
import { ITEMS_PER_PAGE, ResponseWrapper, AuthServerProvider } from '../../shared';
import { CONFIG } from '../../shared/constants/config.constants';
import { DecimalPipe } from '@angular/common';
import { SystemSettingStorageService } from '../../shared/utils/system-setting-storage.service';
import { PermissionService } from '../../shared/utils/permissions.service';
// import { TabsetComponent } from 'ngx-bootstrap/tabs/tabset.component';


@Component({
    selector: 'jhi-division-information',
    templateUrl: './system-setting.component.html',
    styleUrls: ['./system-setting.styl'],
})
export class SystemSettingComponent implements OnInit, OnDestroy {

    // @ViewChild('tabs') tabset: TabsetComponent;

    systemSetting = new SystemSetting();
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalSystemSettings: any;
    queryCount: any;
    systemSettingsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    pmsConf = CONFIG.permissions
    optionGenInvoiceNumber: any
    tabSelected: number = -1;
    private subscription: Subscription;

    constructor(
        private systemSettingService: SystemSettingService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        // private eventManager: JhiEventManager,
        private authServerProvider: AuthServerProvider,
        private systemSettingStorageService: SystemSettingStorageService,
        private pmsServ: PermissionService,
    ) {
    }

    // loadAll() {
    //     if (this.authServerProvider.getInfo() && this.authServerProvider.getInfo().company) {
    //         this.systemSetting = this.authServerProvider.getInfo().company;
    //     } else {
    //         this.systemSetting = new SystemSetting();
    //     }
    // }

    loadAll() {
        this.systemSetting = this.systemSettingStorageService.getSystemSetting();
        this.subscription = this.activatedRoute.params.subscribe((params) => {
            if (params['tabId']){
                this.tabSelected = params['tabId'];
            }
            else{
                this.tabSelected = 0;
            }
            // this.selectTab(this.tabSelected);
        })
    }

    loadPage(page: number) {
        this.previousPage = page;
        this.transition();
    } 

    transition() {
        this.loadAll();
    }

    // selectTab(tabId: number){
    //     if (tabId){
    //         this.tabset.tabs[tabId].active = true;
    //     }
    // }

    ngOnInit() {
        this.loadAll();
        this.registerChangeInSystemSettings();
        this.loadDefaultGenNumberOption();
    }

    ngOnDestroy() {
        // this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInSystemSettings() {
        // this.eventSubscriber = this.eventManager.subscribe('invoiceReleaseListModification', (response) => this.loadAll());
    }

    example(decimalNumber: number = 0){
        var numberExample = 123456;
        var formatString = '1.' + decimalNumber.toString() + '-' + decimalNumber.toString();
        
        return DecimalPipe.prototype.transform(numberExample, formatString);
    }

    checkPermission(permission){
        return this.pmsServ.checkPerm(permission)
    }

    // editSystemSetting(){
    //     this.tabSelected = 0;
    //     var i: number;
    //     for (i = 0; i < this.tabset.tabs.length; i++){
    //         if (this.tabset.tabs[i].active === true){
    //             this.tabSelected = i;
    //             break;
    //         }
    //     }
    //     this.router.navigate(['/system-setting/edit' + "/" + this.tabSelected]);
    // }

    private loadDefaultGenNumberOption() {
        this.optionGenInvoiceNumber = [{
            code: 1,
            name: "afterApprove",
        }, {
            code: 2,
            name: "afterSign",
        }
        ];
    }
}
